import { persistReducer } from 'redux-persist'
import hardSet from 'redux-persist/es/stateReconciler/hardSet'
import storage from 'redux-persist/lib/storage'
import { ContactData } from 'src/Libs/user/models'
import { Company, UserAction, UserActionType, UserData } from './UserModel'
import { isEqual } from 'lodash'

interface UserState {
  userData?: UserData
  contactData?: ContactData
  company?: Company
}

const initialState: UserState = {
  userData: undefined,
  contactData: undefined,
  company: undefined,
}

const userReducer = (state: UserState = initialState, action: UserAction): UserState => {
  switch (action.type) {
    case UserActionType.updateUserData:
      // set initial state
      if (isEqual(state.userData, action.userData)) return state

      if (!state.userData) {
        return {
          ...state,
          userData: action.userData as UserData,
        }
      }

      return {
        ...state,
        userData: { ...state.userData, ...action.userData },
      }
    case UserActionType.resetUserData:
      return {
        ...state,
        userData: undefined,
      }
    case UserActionType.updateContactData:
      if (isEqual(state.contactData, action.contactData)) return state
      // set initial state
      if (!state.contactData) {
        return {
          ...state,
          contactData: action.contactData,
        }
      }

      return {
        ...state,
        contactData: { ...state.contactData, ...action.contactData },
      }
    case UserActionType.resetContactData:
      return {
        ...state,
        contactData: undefined,
      }
    case UserActionType.updateCompanyAddress:
      if (isEqual(state.company, action.company)) return state

      return {
        ...state,
        company: action.company,
      }
    default:
      return state
  }
}

const persistConfig = {
  key: 'user-data',
  storage: storage,
  whitelist: ['userData'],
  stateReconciler: hardSet,
}

export default persistReducer(persistConfig, userReducer)
